module.exports = __webpack_public_path__ + "img/ic-square-maps.eaf57161.svg";